import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const Toggle = ({ dataTestId, checked, onClick, disabled, size, color = 'secondary', isPermanentColor = false, type, name }) => {
    const buttonClassName = classNames('rounded-full group leading-6', checked || isPermanentColor
        ? `bg-${color} disabled:bg-gray-400`
        : 'bg-gray-200 disabled:bg-gray-200', {
        'w-[52px] md:w-11 h-[32px] md:h-6': !size,
        'w-9 h-4': size === 'sm',
        'w-11 h-6': size === 'md',
        'w-[52px] h-[32px]': size === 'lg'
    });
    const circleClassName = classNames('rounded-full transition-all pointer-events-none inline-block shadow-sm', checked ? 'translate-x-2.5' : '-translate-x-2.5', {
        'bg-gray-100': disabled && !checked,
        'bg-gray-200': disabled && checked,
        'bg-white group-hover:shadow': !disabled,
        'w-[28px] md:w-[20px] h-[28px] md:h-[20px]': !size,
        'border border-gray-200 -translate-y-0.5': size === 'sm',
        'w-[20px] h-[20px]': size === 'sm' || size === 'md',
        'translate-y-0.5': !size || size === 'md' || size === 'lg',
        'w-[28px] h-[28px]': size === 'lg'
    });
    return (_jsx("button", { className: buttonClassName, "data-testid": dataTestId, disabled: disabled, onClick: onClick, type: type, name: name, children: _jsx("div", { className: circleClassName }) }));
};
